var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-categoryBox", class: _vm.boxModifier }, [
    _c("div", { staticClass: "c-categoryBox_grid c-categoryBox_grid--info" }, [
      _c(
        "div",
        { staticClass: "c-categoryBox_row c-categoryBox_row--alignStart" },
        [
          _c(
            "div",
            { staticClass: "c-categoryBox_wrap c-categoryBox_wrap--title" },
            [
              _c("avatar-company", {
                staticClass: "c-categoryBox_logo",
                attrs: {
                  logo: _vm.company.logo,
                  name: _vm.company.name,
                  alt: `logo da empresa ${_vm.company.name}`,
                  title: _vm.company.name,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "c-categoryBox_nameWrap" }, [
                _c(
                  "h2",
                  { staticClass: "c-categoryBox_name" },
                  [
                    _vm._t("name"),
                    _vm._v(" "),
                    _vm.checked
                      ? _c("p", {
                          staticClass:
                            "c-categoryBox_badge c-categoryBox_badge--verified tooltip-multiline tooltip-bottom tooltip-text-center",
                          attrs: { "data-tooltip": "Verificado" },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.isAdmPartner
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "c-categoryBox_360 tooltip-dark tooltip-multiline tooltip-bottom-left tooltip-lg tooltip-text-center",
                        attrs: {
                          "data-tooltip":
                            "Esta empresa é parceira do SíndicoNet e também utiliza o CoteiBem para fazer cotações para os seus clientes, garantindo mais transparência e segurança aos condomínios administrados.",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "c-categoryBox_stampIcon",
                          attrs: {
                            src: require("icon/custom/selo-360-small.svg"),
                            alt: "",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-categoryBox_row" }, [
        _c(
          "div",
          { staticClass: "c-categoryBox_wrap c-categoryBox_wrap--info" },
          [_vm._t("description")],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-categoryBox_row c-categoryBox_row--alignEnd" },
        [
          _c(
            "div",
            {
              staticClass: "c-categoryBox_wrap c-categoryBox_wrap--link",
              on: {
                click: function ($event) {
                  return _vm.trackClick()
                },
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "c-categoryBox_link c-categoryBox_link--small",
                  attrs: {
                    href: _vm.profileUrl,
                    title: "ver perfil da empresa",
                  },
                },
                [_vm._v("\n          Ver mais no perfil da empresa\n        ")]
              ),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-categoryBox_grid c-categoryBox_grid--rating" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasRating,
                expression: "hasRating",
              },
            ],
            staticClass: "c-categoryBox_row c-categoryBox_row--alignCenter",
          },
          [
            _c(
              "div",
              { staticClass: "c-categoryBox_wrap c-categoryBox_wrap--score" },
              [
                _c("p", { staticClass: "c-categoryBox_score" }, [
                  _vm._v(_vm._s(_vm.companyRating)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-categoryBox_wrap c-categoryBox_wrap--rating" },
              [
                _c("i", {
                  staticClass: "c-categoryBox_star",
                  class: _vm.ratingStyle,
                }),
                _vm._v(" "),
                _c("p", { staticClass: "c-categoryBox_legend" }, [
                  _vm._v(
                    "(" + _vm._s(_vm.company.totalEvaluation) + ") opiniões"
                  ),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasRating,
                expression: "!hasRating",
              },
            ],
            staticClass: "c-categoryBox_row",
          },
          [
            _c(
              "div",
              { staticClass: "c-categoryBox_wrap c-categoryBox_wrap--empty" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "m-emptyState m-emptyState--row m-emptyState--micro",
                  },
                  [
                    _c("img", {
                      staticClass: "m-emptyState_image",
                      attrs: {
                        src: require("icon/custom/category-star-hourglass.svg"),
                        alt: "poste indicador",
                        title: "endereco não encontrado",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "m-emptyState_title" }, [
                      _vm._v(
                        "Este fornecedor ainda não tem avaliações de usuários"
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-categoryBox_row" },
          [
            _c("categoryParticipationIndex", {
              attrs: { progress: _vm.company.participationIndex },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-categoryBox_row c-categoryBox_row--alignEnd" },
          [
            _c(
              "div",
              { staticClass: "c-categoryBox_wrap c-categoryBox_wrap--button" },
              [
                _c(
                  "button",
                  {
                    staticClass: "c-categoryBox_button",
                    class: _vm.buttonStyle,
                    on: {
                      click: function ($event) {
                        return _vm.toggleCompany()
                      },
                    },
                  },
                  [_vm._v("\n          Adicionar\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "c-categoryBox_wrap c-categoryBox_wrap--heart",
                  },
                  [
                    _c("button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isFavorite,
                          expression: "isFavorite",
                        },
                      ],
                      staticClass:
                        "c-categoryBox_heart c-categoryBox_heart--loved",
                      on: {
                        click: function ($event) {
                          return _vm.removeFavorite(_vm.company)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isFavorite,
                          expression: "!isFavorite",
                        },
                      ],
                      staticClass: "c-categoryBox_heart",
                      on: {
                        click: function ($event) {
                          return _vm.addFavorite(_vm.company)
                        },
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }